// extracted by mini-css-extract-plugin
export default {"globalStyles":"Styles_globalStyles__+ixvG","sm":"Styles_sm__c4io0","sp":"Styles_sp__SQjhD","site-layout-background":"Styles_site-layout-background__n3Vb6"};